import React, { useState } from 'react'
import {
    Box,
    Card,
    CardContent,
    IconButton,
    Typography,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
} from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import CancelIcon from '@material-ui/icons/Cancel'
import SaveIcon from '@material-ui/icons/Save'
import { StripeConnectAccount } from '../../../../../../models/Rent/types'
interface Props {
    stripeConnectAccount: StripeConnectAccount | null
    updateStipeConnectAccount: (params: StripeConnectAccount) => void
}
export const StripeFees: React.FC<Props> = ({
    stripeConnectAccount,
    updateStipeConnectAccount,
}) => {
    const [isEditing, setIsEditing] = useState(false)
    const [editDialogOpen, setEditDialogOpen] = useState(false)
    const [editpercentageFee, setPercentageFee] = useState<string | null>(null)
    const [editflatFee, setFlatFee] = useState<string | null>(null)
    const [isUpdating, setIsUpdating] = useState(false)

    const handleEditClick = () => {
        if (stripeConnectAccount) {
            setPercentageFee(
                stripeConnectAccount.ezos_application_percentage_fee.toString(),
            )
            setFlatFee(
                stripeConnectAccount.ezos_application_flat_fee.toString(),
            )
        }
        setEditDialogOpen(true)
    }
    const handleCancel = () => {
        setEditDialogOpen(false)
        setPercentageFee(null)
        setFlatFee(null)
    }
    const handleSave = async () => {
        if (stripeConnectAccount) {
            setIsUpdating(true)
            try {
                await updateStipeConnectAccount({
                    ...stripeConnectAccount,
                    ezos_application_percentage_fee: parseFloat(
                        editpercentageFee || '0',
                    ),
                    ezos_application_flat_fee: parseFloat(editflatFee || '0'),
                })
                setIsUpdating(false)
                setEditDialogOpen(false)
            } catch (error) {
                console.error('Failed to update stripe fees:', error)
                alert('Failed to update stripe fees')
            } finally {
                setIsUpdating(false)
            }
        }
    }
    if (!stripeConnectAccount) {
        return (
            <Box>
                <Typography variant="h6">
                    No Stripe Connect Account Found
                </Typography>
            </Box>
        )
    }

    return (
        <Box>
            <Card elevation={2} style={{ marginBottom: 16, maxWidth: 700 }}>
                <CardContent style={{ padding: 16 }}>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Box>
                            <Typography
                                variant="h6"
                                style={{ fontWeight: 600 }}
                            >
                                Stripe Processing Fee
                            </Typography>
                        </Box>
                        <IconButton
                            size="small"
                            style={{ marginLeft: 8 }}
                            onClick={handleEditClick}
                            title="Edit billing configuration"
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Box>
                    <Divider style={{ margin: '8px 0' }} />
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        alignItems="center"
                        justifyContent="flex-start"
                    >
                        <Box mr={3} mb={1}>
                            <Typography variant="body2" color="textSecondary">
                                Percentage Fee
                            </Typography>
                            <Typography variant="subtitle1">
                                {
                                    stripeConnectAccount.ezos_application_percentage_fee
                                }
                                %
                            </Typography>
                        </Box>
                        <Box mr={3} mb={1}>
                            <Typography variant="body2" color="textSecondary">
                                Flat Fee
                            </Typography>
                            <Typography variant="subtitle1">
                                $
                                {stripeConnectAccount.ezos_application_flat_fee}
                            </Typography>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
            {/* Edit Stripe Fees Dialog */}
            <Dialog
                open={editDialogOpen}
                onClose={handleCancel}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Edit Stripe Fees</DialogTitle>
                <DialogContent>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ marginBottom: 16 }}
                    >
                        Update the stripe fees for this property.
                    </Typography>
                    <TextField
                        fullWidth
                        label="Percentage Fee"
                        type="number"
                        value={editpercentageFee}
                        onChange={(e) => setPercentageFee(e.target.value)}
                        inputProps={{ step: '0.01' }}
                        variant="outlined"
                        margin="normal"
                        helperText="Number of billable units"
                    />
                    <TextField
                        fullWidth
                        label="Flat Fee"
                        type="number"
                        value={editflatFee}
                        onChange={(e) => setFlatFee(e.target.value)}
                        inputProps={{ step: '0.01' }}
                        variant="outlined"
                        margin="normal"
                        helperText="Rate per billable unit"
                        InputProps={{
                            startAdornment: '$',
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCancel}
                        color="primary"
                        startIcon={<CancelIcon />}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSave}
                        color="primary"
                        variant="contained"
                        disabled={isUpdating}
                        startIcon={<SaveIcon />}
                    >
                        {isUpdating ? 'Saving...' : 'Save Changes'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}
